import React from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import UserRolesForm from './forms/UserRolesForm';
import {
    fetchUserRoles,
    fetchUserSites,
    fetchUserLanguages,
    updateUserRoles
} from './thunks';
import {fetchRoles} from '../roles/thunks';
import {fetchSites} from '../sites/thunks';
import {fetchLanguages} from '../languages/thunks';

class UserEdits extends React.Component {

    componentWillMount() {
        this.props.fetchRoles();
        this.props.fetchSites();
        this.props.fetchLanguages();
        this.props.fetchUserRoles(this.props.userId);
        this.props.fetchUserSites(this.props.userId);
        this.props.fetchUserLanguages(this.props.userId);
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleUserRolesSubmit(formProps) {
        this.props.updateUserRoles(formProps);
    }

    render() {
        return (
            this.props.loading !== true &&
            <UserRolesForm
                userName={this.props.userName}
                allRoles={this.props.allRoles}
                allSites={this.props.allSites}
                allLanguages={this.props.allLanguages}
                initialValues={this.props.initialValues}
                classes={this.props.classes}
                loading={this.props.loading}
                handleFormSubmit={this.handleUserRolesSubmit.bind(this)}
            />
        )
    }
};

const mapStateToProps = (state, props) => ({
    allRoles: state.roles.allRoles,
    allSites: state.sites.all,
    allLanguages: state.languages.all,
    loading: state.layout.ajaxCallsInProgress > 0,
    initialValues: {
        roles: state.users.userRoles,
        sites: state.users.userSites,
        languages: state.users.userLanguages,
        id: state.users.user.id
    },
});

export default connect(mapStateToProps, {
    fetchUserRoles,
    fetchUserSites,
    fetchUserLanguages,
    fetchRoles,
    fetchLanguages,
    fetchSites,
    updateUserRoles,
})(withStyles(styles)(UserEdits));


// WEBPACK FOOTER //
// ./src/containers/users/UserEdits.jsx